import React, { useEffect, useState } from 'react'
import { getItemPrices } from './services/api'

const formatPrice = (value) => (+value > 0 ? (+value)?.toLocaleString() : '-')

export default function SalePriceTable() {
    const [data, setData] = useState([])

    useEffect(() => {
        const getData = async () => {
            const result = await getItemPrices()
            setData(result || [])
        }
        getData()
    }, [])

    return (
        <>
            <h2 className='dash-title'>ราคาขายเมล็ดพันธุ์ดี</h2>
            <div class="col-md-12 table-responsive-sm" style={{ height: '300px', margin: '20px 0' }}>
                <table class="table table-bordered table-hover salePriceTable">
                    <thead style={{
                        background: '#fef5da',
                        color: '#382e6d',
                        position: 'sticky',
                        top: 0,
                        zIndex: 10
                    }}>
                        <tr>
                            <th scope="col" rowspan="2" class="text-center">พันธุ์</th>
                            <th scope="col" colspan="3" class="text-center">ราคาขาย (บาท/กก.)</th>
                        </tr>
                        <tr>
                            <th scope="col" class="text-center">ชั้นพันธุ์หลัก</th>
                            <th scope="col" class="text-center">ชั้นพันธุ์ขยาย</th>
                            <th scope="col" class="text-center">ชั้นพันธุ์จำหน่าย</th>
                        </tr>
                    </thead>
                    <tbody>
                        {data?.length > 0 ? data.map((x, i) => (
                            <tr key={i}>
                                <td class="text-center" style={{ verticalAlign: 'middle' }}>{x?.CatalogName}</td>
                                <td class="text-center cp">{formatPrice(x?.Class0Price)}</td>
                                <td class="text-center cp">{formatPrice(x?.Class1Price)}</td>
                                <td class="text-center cp">{formatPrice(x?.Class2Price)}</td>
                            </tr>
                        )) : (
                            <tr>
                                <td colspan="4" class="text-center" style={{ padding: '20px' }}>ไม่มีข้อมูลราคาขาย</td>
                            </tr>
                        )}
                    </tbody>
                </table>
            </div>
        </>
    )
}
